import { AllCommands } from '../../../../selectors/cardCommandSelectors';
import { messages } from './Actions.messages';

export const commandInfo: {
    [key: string]: { text: string | null; title: string; confirmation?: string };
} = {
    showHelp: {
        text: null,
        title: messages.showContextHelp,
    },
    createTemplate: {
        text: null,
        title: messages.templateCardUpdateButtonTitle,
    },
    saveDraftTemplate: {
        text: null,
        title: messages.templateCardUpdateButtonTitle,
    },
    updateEnabledTemplate: {
        text: messages.templateCardUpdateEnabledButton,
        title: messages.templateCardUpdateEnabledButtonTitle,
    },
    discardTemplateChanges: {
        text: messages.templateCardDiscardButton,
        title: messages.templateCardDiscardButtonTitle,
        confirmation: messages.discardTemplateChangesPrompt,
    },
    deleteTemplate: {
        text: messages.templateCardDeleteButton,
        title: messages.templateCardDeleteButtonTitle,
        confirmation: messages.removeTemplateConfirmPrompt,
    },
    startOver: {
        text: messages.startOverDialogButton,
        title: messages.startOverDialogButtonTitle,
    },
    enableTemplate: {
        text: messages.templateCardEnableButton,
        title: messages.templateCardEnableButtonTitle,
    },
    disableTemplate: {
        text: messages.templateCardDisableButton,
        title: messages.templateCardDisableButtonTitle,
    },
    openTemplateSettings: {
        text: null,
        title: messages.changeTemplateSettingsButtonTitle,
    },
    openVersionHistory: {
        text: null,
        title: messages.openVersionHistoryButtonTitle,
    },
    copyTemplate: {
        text: messages.copyTemplateButton,
        title: messages.copyTemplateButtonTitle,
    },
};

export const menuCommandIds: Array<keyof AllCommands> = [
    'startOver',
    'discardTemplateChanges',
    'disableTemplate',
    'deleteTemplate',
    'copyTemplate',
];
export const saveButtonCommandIds: Array<keyof AllCommands> = ['saveDraftTemplate', 'createTemplate'];
export const largeButtonCommandIds: Array<keyof AllCommands> = ['updateEnabledTemplate', 'enableTemplate'];
